


































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class MemberBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly fetchReportProvider!: Function;

  @Prop() readonly fetchReportProviderByType!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly providerName!: string;

  @Prop() readonly type!: string;

  utilsInstance = utils;

  onClickProviderName(provider, name) {
    this.fetchReportProvider(provider, name);
  }

  onClickProviderType(provider, type) {
    this.fetchReportProviderByType(provider, type);
  }
}
